import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import PopupWindowPayment from './popupWindow';

export default class PaymentRequestFrame extends React.Component {
  static propTypes = {
    paymentRequest: PropTypes.shape({
      signature: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      merchantReferenceCode: PropTypes.string.isRequired,
      member: PropTypes.shape({
        id: PropTypes.string,
        lastName: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        addressLine1: PropTypes.string.isRequired,
        addressLine2: PropTypes.string,
        city: PropTypes.string.isRequired,
        zipCode: PropTypes.string.isRequired,
        emailAddress: PropTypes.string,
        country: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        phoneNumber: PropTypes.string.isRequired,
      }).isRequired,
    }),
    onPaymentComplete: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const paymentFields = {};
    const { paymentRequest } = props;
    if (paymentRequest.member.id) {
      paymentFields.account_id = paymentRequest.member.id;
    }
    paymentFields.bill_to_forename = paymentRequest.member.firstName;
    paymentFields.person_first_name = paymentRequest.member.firstName;
    paymentFields.bill_to_surname = paymentRequest.member.lastName;
    paymentFields.person_last_name = paymentRequest.member.lastName;
    paymentFields.merchant_id = process.env.MERCHANT_ID;
    paymentFields.amount = paymentRequest.amount;
    paymentFields.bill_to_email = isEmpty(paymentRequest.member.emailAddress) ? 'null@cybersource.com' : paymentRequest.member.emailAddress;
    paymentFields.bill_to_phone = paymentRequest.member.phoneNumber;
    paymentFields.bill_to_address_line1 = paymentRequest.member.addressLine1;
    if (!isEmpty(paymentRequest.member.addressLine2)) {
      paymentFields.bill_to_address_line2 = paymentRequest.member.addressLine2;
    }
    paymentFields.bill_to_address_city = paymentRequest.member.city;
    paymentFields.bill_to_address_state = paymentRequest.member.state;
    paymentFields.bill_to_address_country = paymentRequest.member.country;
    paymentFields.bill_to_address_postal_code = paymentRequest.member.zipCode;
    paymentFields.displayEcheck = (paymentRequest.member.paymentMethod === 'eCheck' ? 'yes' : 'no');
    paymentFields.merchant_reference_code = paymentRequest.merchantReferenceCode;
    paymentFields.dso_authentication = paymentRequest.signature;
    paymentFields.redirect_url = process.env.DSM_CALLBACK_SERVICE;

    const url = process.env.DSM_ENDPOINT;
    this.state = { url, paymentFields };
  }

  // called with response params from DSM
  onPaymentComplete = (data) => {
    this.props.onPaymentComplete(data);
  };

  render() {
    const { url, paymentFields } = this.state;
    return (
      <PopupWindowPayment
        url={url}
        paymentFields={paymentFields}
        onPaymentComplete={this.onPaymentComplete}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/PaymentRequestFrame/index.js